export const vertexShader = () => {
  return `
        uniform vec2 uMouse;
        uniform float uHover;

          varying vec2 vUv;

          void main() {
            vUv = uv;
            vec3 pos = position;

            if (uHover > 0.5) {
              float dist = distance(uv, uMouse);
              float strength = 0.3;
              float radius = 0.8; 
              float falloff = smoothstep(radius, 0.0, dist);
              pos.z += falloff * strength;
            }

            gl_Position = projectionMatrix * modelViewMatrix * vec4(pos, 1.0);
          }
      `;
};
